export default "__VITE_ASSET__B655F692__"